/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Test_ButtonInputs */

const en_admin_settings_test_button = /** @type {(inputs: Admin_Settings_Test_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

/**
* | output |
* | --- |
* | "Test" |
*
* @param {Admin_Settings_Test_ButtonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_test_button = /** @type {((inputs?: Admin_Settings_Test_ButtonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Test_ButtonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_test_button(inputs)
});
export { admin_settings_test_button as "admin.settings.test.button" }